/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerUpdateSavedVersionMutationResponse, AiAgentV2ControllerUpdateSavedVersionPathParams } from "../../models/aiAgentV2Controller/AiAgentV2ControllerUpdateSavedVersion";

function getAiAgentV2ControllerUpdateSavedVersionUrl(requestId: AiAgentV2ControllerUpdateSavedVersionPathParams["requestId"]) {
  const res = { method: 'PATCH', url: `/api/v1/ai-agent-v2/requests/${requestId}/saved-version` as const }  
  return res
}

/**
 * @description Updates the redlining or compliance thinking-step message with the saved version number so it survives page refreshes.
 * @summary Persist the saved version number for a redline request
 * {@link /api/v1/ai-agent-v2/requests/:requestId/saved-version}
 */
export async function aiAgentV2ControllerUpdateSavedVersion(requestId: AiAgentV2ControllerUpdateSavedVersionPathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerUpdateSavedVersionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PATCH", url : getAiAgentV2ControllerUpdateSavedVersionUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}